import {
  DEFAULT_VALUE,
  PAYLOAD_TYPE_INDICATOR_ENUM,
  TRANSACTION_TYPE_ENUM,
  billingPreferenceMap,
  shippingPreferencesMap,
  threeDsPreferenceMap
} from '../constants/external-sdk-maps';
import isEmptyObject from './is-empty-object';

// START GENAI@GHCOPILOT
/**
 * Decodes HTML entities in a given string.
 *
 * @param {string} html - The HTML string to decode.
 * @returns {string} The decoded string.
 */
const decodeHtml = html => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.documentElement.textContent;
};
// END GENAI@GHCOPILOT

/**
 * Method to remove null, undefined & empty from the object
 *
 * @param  {obj} obj - Parsed Intent data
 * @return {object} Object - return clean object
 */
const cleanObject = obj => {
  Object.keys(obj).forEach(key => {
    const val = obj[key];
    if (val && typeof val === 'object') {
      cleanObject(obj[key]);
    } else if (val === '' || val === null || val === undefined) {
      delete obj[key];
    }
  });
  return obj;
};

/* eslint-disable */
const mapMerchantConfig = (dpaData, dpaTransactionOptions) => {
  let billingConstraints,
    consumerEmailAddressRequested,
    consumerNameRequested,
    consumerNationalIdentifierRequested,
    consumerPhoneNumberRequested,
    countryCode,
    dataLevel,
    displayName,
    dpaDynamicDataTtlMinutes,
    enableThreeDS,
    locale,
    merchantCategoryCode,
    orderType,
    reviewMessage,
    shippingConstraints,
    srcDpaId,
    threeDSSetup,
    tokenizationSetup,
    transactionType,
    websiteUrl;

  if (!isEmptyObject(dpaData)) {
    // START GENAI@GHCOPILOT
    displayName = decodeHtml(dpaData.dpaPresentationName);
    // END GENAI@GHCOPILOT
    srcDpaId = dpaData.srcDpaId;
    websiteUrl = dpaData.dpaUri;
    threeDSSetup = {};
    threeDSSetup.threeDSActive =
      threeDsPreferenceMap[dpaData.dpaThreeDsPreference] ||
      threeDsPreferenceMap[(dpaTransactionOptions?.threeDsPreference)] ||
      DEFAULT_VALUE.THREE_DS_ACTIVE;
    enableThreeDS = threeDSSetup.threeDSActive;
  }

  if (!isEmptyObject(dpaTransactionOptions)) {
    const {
      dpaBillingPreference,
      dpaShippingPreference,
      paymentOptions,
      threeDsInputData
    } = dpaTransactionOptions;
    consumerEmailAddressRequested = dpaTransactionOptions.consumerEmailAddressRequested;
    consumerNameRequested = dpaTransactionOptions.consumerNameRequested;
    consumerPhoneNumberRequested = dpaTransactionOptions.consumerPhoneNumberRequested;
    countryCode = dpaTransactionOptions.merchantCountryCode;
    consumerNationalIdentifierRequested = dpaTransactionOptions.consumerNationalIdentifierRequested;
    dataLevel = PAYLOAD_TYPE_INDICATOR_ENUM.includes(dpaTransactionOptions.payloadTypeIndicator)
      ? dpaTransactionOptions.payloadTypeIndicator
      : DEFAULT_VALUE.PAYLOAD_TYPE_INDICATOR;
    locale = dpaTransactionOptions.dpaLocale;
    merchantCategoryCode = dpaTransactionOptions.merchantCategoryCode;
    orderType = dpaTransactionOptions.orderType;
    reviewMessage = dpaTransactionOptions.checkoutDescription;
    transactionType = TRANSACTION_TYPE_ENUM.includes(dpaTransactionOptions.transactionType)
      ? dpaTransactionOptions.transactionType
      : DEFAULT_VALUE.TRANSACTION_TYPE;
    billingConstraints = {};
    shippingConstraints = {};
    billingConstraints.collectBillingAddress =
      billingPreferenceMap[dpaBillingPreference] || DEFAULT_VALUE.COLLECT_BILLING_ADDRESS;
    let collectShipping = shippingPreferencesMap[dpaShippingPreference];
    if (collectShipping === undefined) {
      collectShipping = DEFAULT_VALUE.COLLECT_SHIPPING;
    }
    shippingConstraints.collectShipping = collectShipping;
    // to support All countries, ignore the billingConstraints.acceptedRegions props
    if (
      !isEmptyObject(dpaTransactionOptions.dpaAcceptedBillingCountries) &&
      dpaTransactionOptions.dpaAcceptedBillingCountries.length
    ) {
      const billingRegion = dpaTransactionOptions.dpaAcceptedBillingCountries.map(country => ({
        countryCode: country
      }));

      billingConstraints.acceptedRegions = { region: billingRegion };
    }
    // to support All countries, ignore the shippingConstraints.acceptedRegions prop
    if (
      !isEmptyObject(dpaTransactionOptions.dpaAcceptedShippingCountries) &&
      dpaTransactionOptions.dpaAcceptedShippingCountries.length
    ) {
      const shippingRegion = dpaTransactionOptions.dpaAcceptedShippingCountries.map(country => ({
        countryCode: country
      }));

      shippingConstraints.acceptedRegions = { region: shippingRegion };
    }

    if (!isEmptyObject(paymentOptions)) {
      dpaDynamicDataTtlMinutes = paymentOptions.dpaDynamicDataTtlMinutes;
      tokenizationSetup = {};
      tokenizationSetup.enableTokenization = !paymentOptions.dpaPanRequested;
      tokenizationSetup.tokenCryptogramType = paymentOptions.dynamicDataType;
    }

    if (!isEmptyObject(threeDsInputData) && threeDSSetup && threeDSSetup.threeDSActive) {
      threeDSSetup.acquirerId = threeDsInputData.acquirerId;
      threeDSSetup.requestorId = threeDsInputData.requestorId;
      threeDSSetup.acquirerMid = threeDsInputData.acquirerMid;
    }
  } else {
    // VCO-15379 set default val even when dpaTransactionOptions not passed
    shippingConstraints = { collectShipping: DEFAULT_VALUE.COLLECT_SHIPPING };
  }

  const merchantConfig = {
    billingConstraints,
    consumerEmailAddressRequested,
    consumerNameRequested,
    consumerNationalIdentifierRequested,
    consumerPhoneNumberRequested,
    countryCode,
    dataLevel,
    dpaDynamicDataTtlMinutes,
    enableThreeDS,
    displayName,
    locale,
    merchantCategoryCode,
    orderType,
    reviewMessage,
    shippingConstraints,
    srcDpaId,
    threeDSSetup,
    tokenizationSetup,
    transactionType,
    websiteUrl
  };
  const cleanMerchantConfig = cleanObject(merchantConfig);
  return cleanMerchantConfig;
};

export default mapMerchantConfig;
